module.exports = __webpack_public_path__ + "img/us6.e0f01a6f.png";